import { createSlice } from '@reduxjs/toolkit';
import client from 'api/apiClient';
import { createAsyncThunkWrapper } from 'redux/thunk/createAsyncThunkWrapper';
import { getBasketData } from 'services/getBasketData';
import { FetchGivingBasketPayload, GivingBasketState, UpdateBasketStatus } from 'types/baskets';
import { EventStatus } from 'types/common';
import { getDefaultCompanyId } from 'utils/helpers';

const initialState: GivingBasketState = {
    activeRecords: [],
    inActiveRecords: [],
    loading: true,
    error: null,
    loadMore: false,
};
export const getStatus = (status: EventStatus) => (Array.isArray(status) ? status[0] : status);

export const updateBasketStatus = createAsyncThunkWrapper<any, UpdateBasketStatus>('update/updateBasketStatus', async ({ status, id }) => {
    const response = await client.put(`/event/status/${id}`, { status });
    return response;
});

export const fetchGivingBasket = createAsyncThunkWrapper<any, FetchGivingBasketPayload>(
    'giving/fetchGivingBasket',
    async ({ status, subType, headers, name, companyId }: FetchGivingBasketPayload, { getState }) => {
        const { pageSize, pageNumber } = headers;
        const state: any = getState();
        const defaultCompanyId = getDefaultCompanyId(state);
        if (!defaultCompanyId) {
            return;
        }
        const response = await getBasketData({ status, subType, companyId: companyId ? +companyId : defaultCompanyId, headers, name });
        if (!response) return;
        return { response, pageNumber, pageSize, status };
    }
);

const givingBasketSlice = createSlice({
    name: 'givingBasket',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchGivingBasket.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(fetchGivingBasket.fulfilled, (state, action) => {
            state.loading = false;
            const { payload } = action || {};
            if (!Array.isArray(payload?.response?.events)) return;

            const { response, pageNumber, pageSize = 0, status = 'ACTIVE' } = payload || {};
            const { events } = response || {};
            state.loadMore = events?.length >= pageSize;

            const keyToUpdate = getStatus(status) === 'PENDING' ? 'inActiveRecords' : 'activeRecords';
            state[keyToUpdate] = !pageNumber ? events || [] : [...(state?.[keyToUpdate] || []), ...(events || [])];
        });
        builder.addCase(fetchGivingBasket.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message || null;
        });
    },
});

export default givingBasketSlice.reducer;
